import { render } from "./TankHeader.vue?vue&type=template&id=b79a8692&scoped=true"
import script from "./TankHeader.vue?vue&type=script&lang=js"
export * from "./TankHeader.vue?vue&type=script&lang=js"

import "./TankHeader.vue?vue&type=style&index=0&id=b79a8692&scoped=true&lang=css"

import exportComponent from "/var/www/potabilis/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b79a8692"]])

export default __exports__